export class Validation {
  constructor(public speed?: boolean,
              public rpm?: boolean,
              public gps?: boolean,
              public can?: boolean,
              public files?,
              public canEdit?,
              public canView?,
              public editable?) { }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/attending/model/validation.ts